import Icon from './ui/Icon';
import Reveal from './ui/Reveal';
import RichText from './ui/RichText';
import { guarantee } from '../data/content';

export default function Guarantee() {
  return (
    <section className="alt tight" id="guarantee">
      <div className="wrap">
        <Reveal className="moneyback">
          <div className="ic">
            <Icon name="dollar" />
          </div>
          <h2 className="h-sub">The LNG School Promise</h2>
          {guarantee.map((paragraph) => (
            <p key={paragraph}>
              <RichText text={paragraph} />
            </p>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
